'use client';

/**
 * Unified AI Icons
 *
 * Provides consistent AI-related icons across all portals.
 * Use these instead of importing MUI icons directly for AI features.
 *
 * @see Issue #330 - Unified Design System
 */

import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import HubIcon from '@mui/icons-material/Hub';
import PsychologyIcon from '@mui/icons-material/Psychology';
import type { SvgIconProps } from '@mui/material';
import type React from 'react';

/**
 * Primary AI Icon - Used for AI assistants, chat, and general AI features
 * Uses AutoAwesome (sparkles) which conveys intelligence and magic
 */
export const AiIcon: React.FC<SvgIconProps> = (props) => <AutoAwesomeIcon {...props} />;

/**
 * AI Agent Icon - Used specifically for AI agents
 * Uses Psychology (brain) which conveys thinking and intelligence
 */
export const AgentIcon: React.FC<SvgIconProps> = (props) => <PsychologyIcon {...props} />;

/**
 * AI Bot Icon - Used for chat bots and conversational AI
 * Uses same as AiIcon for consistency
 */
export const BotIcon: React.FC<SvgIconProps> = (props) => <AutoAwesomeIcon {...props} />;

/**
 * AI Hub Icon - Used for AI orchestration and multi-agent systems
 */
export const AiHubIcon: React.FC<SvgIconProps> = (props) => <HubIcon {...props} />;

export default AiIcon;
